import { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import FieldRenderer from './FieldRenderer';
import type { FieldSchema } from './types';

const GroupField = ({ field }: { field: FieldSchema }) => (
  <Grid
    size={12}
    sx={{ padding: 1, border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: '4px', boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)' }}
  >
    <Box display="flex" sx={{ mb: 1 }}>
      <Typography color="text.primary" variant={field.font_size || 'h6'}>
        {field.label}
      </Typography>
      {Object.prototype.hasOwnProperty.call(field, 'help') ? <ChartHelpTooltip chartType={field.help as string} /> : null}
    </Box>
    <Grid container spacing={2}>
      {field.fields?.map((subField, index) => (
        <Fragment key={subField.name || index}>
          <FieldRenderer field={subField} />
        </Fragment>
      ))}
    </Grid>
  </Grid>
);

export default GroupField;
